import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "clearButton" ]

  connect() {
    this.#toggle()
  }

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.#toggle()

    if (this.element.dataset.searchClearRedirect === "true") {
      this.element.requestSubmit()
    }
  }

  input() {
    this.#toggle()
  }

  #toggle() {
    const hasValue = this.inputTarget.value.length > 0
    this.clearButtonTarget.classList.toggle("hidden", !hasValue)
  }
}
